<div [ngClass]="this.menuService.menuOptions['database'] ? 'active' : ''" class="database-menu">
  <div>
    <h1>Database</h1>
    <ul>
      <ng-container *ngIf="gritUserService.allowedRoles(GritUserRoleGroup.FullUser, GritUserRoleGroup.ApprovingEntity)">
        <h4>RFI-Transmitter</h4>
        <app-menu-option
          [action]="this.tabsService.openNewCreateTab.bind(tabsService, TabsService.CREATE_DEVICE)"
          [label]="'Create RFI-Transmitter'">
        </app-menu-option>
        <app-menu-option
          [action]="this.tabsService.openEditDeviceTab.bind(tabsService)"
          [label]="'Edit RFI-Transmitter'">
        </app-menu-option>
        <app-menu-option
          [action]="this.deviceService.deleteDevice.bind(deviceService)"
          [label]="'Delete RFI-Transmitter'">
        </app-menu-option>
      </ng-container>
      <ng-container *ngIf="gritUserService.allowedRoles(GritUserRoleGroup.FullUser)">
      <h4>Radar</h4>
      <app-menu-option
        [action]="this.tabsService.openNewCreateTab.bind(tabsService, TabsService.CREATE_RADAR)"
        [label]="'Create Radar'">
      </app-menu-option>
      <app-menu-option
        [action]="this.tabsService.openEditRadarTab.bind(tabsService)"
        [label]="'Edit Radar'">
      </app-menu-option>
      <app-menu-option
        [action]="this.radarService.deleteRadar.bind(radarService)"
        [label]="'Delete Radar'">
      </app-menu-option>
      </ng-container>

      <ng-container *ngIf="gritUserService.allowedRoles(GritUserRoleGroup.FullUser, GritUserRoleGroup.ReducedUser)">
        <h4>NavAid</h4>
        <app-menu-option
          [action]="this.createNavaid.bind(this)"
          [label]="'Create Navaid'">
        </app-menu-option>
        <app-menu-option
          [action]="this.createNavaidFromMap.bind(this)"
          [label]="'Create NavAid from Map'">
        </app-menu-option>
        <app-menu-option
          [action]="this.editNavaid.bind(this)"
          [label]="'Edit Navaid'">
        </app-menu-option>
        <app-menu-option
          [action]="this.navaidController.deleteNavaids.bind(navaidController)"
          [label]="'Delete NavAid'">
        </app-menu-option>
        <app-menu-option
          [action]="this.navaidDuplicationChecksAll.bind(this)"
          [label]="'Navaid Duplication Check All'">
        </app-menu-option>
        <app-menu-option
          [action]="this.navaidDuplicationsChecksSelected.bind(this)"
          [label]="'Navaid Duplication Check Selected'">
        </app-menu-option>
        <!--<app-menu-option [selectOption]="this.genericController.showMesssageModal('NavAids Duplication Check Selected')">NavAids Duplication Check Selected</app-menu-option>
        <app-menu-option [selectOption]="this.genericController.showMesssageModal(ks'NavAids Duplication Check All')">NavAids Duplication Check All</app-menu-option>-->
        <h4>Coordinate Point</h4>
        <app-menu-option
          [action]="this.createCoordinatePoint.bind(this)"
          [label]="'Create Coordinate Point'">
        </app-menu-option>
        <app-menu-option
          [action]="this.createCPFromNavaid.bind(this)"
          [label]="'Create Coordinate Point from NavAid'">
        </app-menu-option>
        <!-- TODO: ADAPT createCPFromNavaid to ask for azimuth and distance -->
        <app-menu-option
          [action]="this.createCPWithAzimuthAndDistance.bind(this)"
          [label]="'Create Coordinate Point with Azimuth and Distance'">
        </app-menu-option>
        <app-menu-option
          [action]="this.editCP.bind(this)"
          [label]="'Edit Coordinate Point'">
        </app-menu-option>
        <app-menu-option
          [action]="this.coordinatePointsController.deleteCP.bind(coordinatePointsController)"
          [label]="'Delete Coordinate Point'">
        </app-menu-option>
        <app-menu-option
          [action]="this.openCoordinatePointsDuplicationCheckAll.bind(this)"
          [label]="'Coordinate Point Duplication Check All'">
        </app-menu-option>
        <app-menu-option
          [action]="this.openCoordinatePointsDuplicationCheckSelected.bind(this)"
          [label]="'Coordinate Point Duplication Check Selected'">
        </app-menu-option>
      </ng-container>


     <!-- <h4>Procedure</h4>
      <app-menu-option
        [action]="this.createProcedure.bind(this)"
        [label]="'Create Procedure from Map'">
      </app-menu-option>
      <app-menu-option
        [action]="this.createProcedureFromSelectedZone.bind(this)"
        [label]="'Create Procedure from Selected Zone'">
      </app-menu-option>
      &lt;!&ndash;<input hidden #uploadCPFile type="file" (change)="this.createProcedureFromFile($event)"/>
      <app-menu-option [selectOption]="uploadCPFile.value='';uploadCPFile.click">Create Procedure from File  </app-menu-option>&ndash;&gt;
      <app-menu-option
        [action]="this.createProcedureFromRouteSegment.bind(this)"
        [label]="'Create Procedure from Route Segments'">
      </app-menu-option>
      <app-menu-option
        [action]="this.editProcedure.bind(this)"
        [label]="'Edit Procedure'">
      </app-menu-option>
      <app-menu-option
        [action]="this.procedureController.deleteProcedure.bind(procedureController)"
        [label]="'Delete Procedure'">
      </app-menu-option>
      <app-menu-option
        [action]="this.openNewProcedureAssessment.bind(this)"
        [label]="'Procedure Assessment'">
      </app-menu-option>
      <app-menu-option
        [action]="this.procedureNavaidAssociation.bind(this)"
        [label]="'Procedure – NavAid Association'">
      </app-menu-option>
      <h4>Air Space Boundary</h4>
      <app-menu-option
        [action]="this.createAirspaceBoundary.bind(this)"
        [label]="'Create Air Space Boundary from Map'">
      </app-menu-option>
      <app-menu-option
        [action]="this.createAirSpaceBoundaryFromSelectedVertices.bind(this)"
        [label]="'Create Air Space Boundary From Selected Vertices'">
      </app-menu-option>
      &lt;!&ndash; <app-menu-option [selectOption]="this.createAirSpaceBoundaryFromFile">Create Procedure from File  </app-menu-option><input hidden type="file" (change)="this.airspaceBoundariesController.createAirSpaceBoundaryFromFile($event)"/> &ndash;&gt;
      <app-menu-option
        [action]="this.editAirspaceBoundary.bind(this)"
        [label]="'Edit Air Space Boundary'">
      </app-menu-option>
      <app-menu-option
        [action]="this.airspaceBoundariesController.deleteAirspaceBoundary.bind(airspaceBoundariesController)"
        [label]="'Delete Air Space Boundary'">
      </app-menu-option>
      <h4>Trajectory</h4>
      <app-menu-option
        [action]="this.trajectoryController.deleteTrajectory.bind(trajectoryController)"
        [label]="'Delete Trajectory'">
      </app-menu-option>
      <h4> SAAM Traffic Density</h4>
      <app-menu-option
        [action]="this.saamService.deleteSAAMAirSpace.bind(saamService)"
        [label]="'Delete SAAM Traffic Layer'">
      </app-menu-option>
      <h4>Flight Inspection</h4>
      <app-menu-option
        [action]="this.pointsService.deleteFlightInspection.bind(pointsService)"
        [label]="'Delete Flight Inspection Layer'">
      </app-menu-option>
      <app-menu-option
        [action]="this.pointsService.deleteProcessingTool.bind(pointsService)"
        [label]="'Delete FI Processing Tool Layer'">
      </app-menu-option>-->
    </ul>
  </div>
</div>


